import $ from 'jquery';
import slick from 'slick-carousel';


const tourCarouselElement = $('#home .main.site .brace.work .article.tours .nav, #home .main.site .brace.work .article.events .nav');

let rtn = {};



rtn.init = () => {

    if (tourCarouselElement.length > 0) {


        tourCarouselElement.each(function (i, tc) {

            const parentWidth = tourCarouselElement.parent().width(),
                  parentHeight = tourCarouselElement.parent().height(),
                  max = 2000,
                  min = 3000,
                  timer = Math.floor(Math.random()*(max-min+1)+min);

            tc = $(tc);

            tc.width(parentWidth);
            tc.height(Math.round(parentHeight * 0.7));

            tc.slick({
                autoplay: true,
                arrows: false,
                variableWidth: false,
                prevArrow: false,
                nextArrow: false,
                centerMode: false,
                autoplaySpeed: timer
            });


        })

        /**/

    }

};


module.exports = rtn;



// WEBPACK FOOTER //
// ./js/service/tour-carousel.js